/* eslint-disable no-console */

let outputConsole = false;
const pageViewHistory = [];
let defaultName = '';
let defaultHierarchy = [];
let defaultCampaign = '';

const loadTrackingScripts = function(url) {
  if (process.env.NODE_ENV === "development") {
    console.info("*** TRACKING INITIALIZING: %o", window.pageData.page);
  }
  return new Promise((resolve, reject) => {
    if (url) {
      const head = document.head || document.getElementsByTagName("head")[0];
      const script = document.createElement("script");
      script.async = true;
      script.charset = "utf-8";
      head.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.src = url;
    }
    resolve();
  });
};

/**
 * Track a simple virtual page view
 * @param {*} trackObject 
 */
const trackPageView = function(pageObject) {
  if (pageObject.name) {
    window.pageData.page.name = defaultName+pageObject.name
  }
  if (pageObject.hierarchy) {
    window.pageData.page.hierarchy = defaultHierarchy.concat(pageObject.hierarchy)
  }
  
  if (typeof _satellite !== "undefined") {
    _satellite.track('customPageView', window.pageData);
  } else {
    console.warn("Tracking not initialized, _satellite not defined.");
  }
  
  if (outputConsole && process.env.NODE_ENV !== "production") {
    console.log("*** CUSTOM PAGEVIEW (page): %o", window.pageData.page);
  }
  
  pageViewHistory.push(pageObject);
};

const trackPreviousPageView = function() {
  // get object from before
  const pageObject = pageViewHistory[pageViewHistory.length-2];
  trackPageView(pageObject);
}

const trackCustomEvent = function(eventId, eventType = "AdHocEvent") {
  const trackObj = {
    id: eventId,
    pageCampaignName: defaultCampaign,
  };
  
  if (typeof _satellite !== "undefined") {
    _satellite.track(eventType, trackObj);
  } else {
    console.warn("Tracking not initialized, _satellite not defined.");
  }
  
  if (outputConsole && process.env.NODE_ENV !== "production") {
    console.info("*** CUSTOM EVENT ("+eventType+"): %o", trackObj);
  }
}

const trackVideoEvent = function(videoId, videoTitle, videoEvent, eventType = "YTVideoEvent") {
  const trackObj = {
    VideoID: videoId,
    Videotitle: videoTitle,
    Videoevent: videoEvent,
  };
  
  if (typeof _satellite !== "undefined") {
    _satellite.track(eventType, trackObj);
  } else {
    console.warn("Tracking not initialized, _satellite not defined.");
  }
  
  if (outputConsole && process.env.NODE_ENV !== "production") {
    console.info("*** VIDEO EVENT ("+eventType+"): %o", trackObj);
  }
}

export default {
  install(Vue, options) {
    window.pageData = options.defaultTrackObject;
    defaultName = options.defaultName;
    defaultHierarchy = options.defaultHierarchy;
    defaultCampaign = options.defaultCampaign
    
    if (
      !process.env.hasOwnProperty("VUE_APP_TRACKING") ||
      process.env.VUE_APP_TRACKING === "true"
    ) {
      outputConsole = true;
      loadTrackingScripts(options.scriptUrl);
    }
    
    Vue.prototype.$trackPageView = Vue.$trackPageView = trackPageView;
    Vue.prototype.$trackPreviousPageView = Vue.$trackPreviousPageView = trackPreviousPageView;
    Vue.prototype.$trackCustomEvent = Vue.$trackCustomEvent = trackCustomEvent;
    Vue.prototype.$trackVideoEvent = Vue.$trackVideoEvent = trackVideoEvent;
    
  }
};
